import { useAuth } from '../lib/AuthContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

const LOGO = 'https://customer-assets-jai6qajn.emergentagent.net/job_pediatric-dispatch/artifacts/ocaqpxqe___circle%20logo_dark%20purple.jpg';

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate(user.role === 'data_import' ? '/import' : '/dashboard', { replace: true });
  }, [user, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) return null;

  return (
    <div className="min-h-screen gradient-hero flex items-center justify-center px-4">
      <div className="w-full max-w-5xl grid md:grid-cols-2 gap-10 items-center">
        {/* Left — brand story */}
        <div className="space-y-6" data-testid="login-hero">
          <div className="flex items-center gap-4">
            <img src={LOGO} alt="Thrive" className="w-16 h-16 rounded-full shadow-sm" data-testid="thrive-logo" />
            <div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#685B72]/70 font-semibold">Thrive Speech Therapy</div>
              <div className="font-serif text-2xl text-[#2D2833]">Operations Hub</div>
            </div>
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl leading-[1.05] text-[#2D2833]">
            Every referral, every family, every clinic — in one calm workspace.
          </h1>
          <p className="text-[#685B72] text-base leading-relaxed max-w-lg">
            Your command center for intake, scheduling, and billing across all nine Thrive clinics.
            Sign in with your Thrive Google Workspace account to get started.
          </p>
          <div className="flex flex-wrap gap-3 pt-2">
            {['Katy', 'Missouri City', 'Townelake', 'Fry Rd', 'Memorial', 'Brookshire', 'Tomball', 'Magnolia', 'Atascocita'].map(c => (
              <span key={c} className="text-xs px-3 py-1 rounded-full bg-white border border-[#E8E5EC] text-[#685B72]">{c}</span>
            ))}
          </div>
        </div>
        {/* Right — sign in card */}
        <div className="bg-white rounded-2xl border border-[#E8E5EC] p-8 sm:p-10 shadow-sm">
          <h2 className="font-serif text-2xl text-[#2D2833] mb-1">Sign in</h2>
          <p className="text-sm text-[#685B72] mb-6">Access restricted to Thrive team members.</p>
          {new URLSearchParams(window.location.search).get('reason') === 'idle_timeout' && (
            <div
              className="mb-6 rounded-lg px-3 py-2.5 text-[12px] text-[#8A5D2D] bg-[#FBF5E9] border border-[#B08A3A66]"
              data-testid="login-idle-timeout-banner"
            >
              You were automatically signed out after 30 minutes of inactivity — a HIPAA safeguard. Sign in again to continue.
            </div>
          )}
          <Button
            onClick={handleLogin}
            data-testid="google-signin-button"
            className="w-full h-12 bg-[#685B72] hover:bg-[#52475A] text-white rounded-xl text-sm font-semibold transition-colors"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5 mr-2" aria-hidden>
              <path fill="#FFFFFF" d="M12 11v3.2h4.6c-.2 1.2-1.5 3.6-4.6 3.6-2.8 0-5-2.3-5-5.1s2.3-5.1 5-5.1c1.6 0 2.6.7 3.2 1.3l2.2-2.1C15.9 5.6 14.1 4.8 12 4.8 7.9 4.8 4.6 8.1 4.6 12.2s3.3 7.4 7.4 7.4c4.3 0 7.1-3 7.1-7.2 0-.5-.1-.9-.1-1.4H12z"/>
            </svg>
            Continue with Google Workspace
          </Button>
          <div className="mt-6 text-xs text-[#685B72]/80 leading-relaxed">
            New Thrive team member? An admin must approve your account after your first sign-in. If you can't get in,
            contact <span className="font-semibold">Davinder Sekhon</span>.
          </div>
        </div>
      </div>
    </div>
  );
}
